import { List, Map } from 'immutable';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { VALUE } from '../../../../constants/product';
import { SHOPIFY } from '../../../../constants/channels';
import ATTRIBUTE from '../../../../constants/attributes';

export function quantity({ channel, preview }) {
  const payload = [];

  if (preview.hasIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.CONTINUE_SELLING])) {
    payload.push(
      Map({
        type: OPERATIONS[channel].CONTINUE_SELLING.SET,
        value: List([
          Map({
            combination: null,
            offeringId: null,
            value: Map({
              inventoryPolicy: preview.getIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.CONTINUE_SELLING])
                ? 'continue'
                : 'deny',
            }),
          }),
        ]),
      })
    );
  }

  if (preview.hasIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.TRACK_QUANTITY])) {
    payload.push(
      Map({
        type: OPERATIONS[channel].TRACK_QUANTITY.SET,
        value: List([
          Map({
            combination: null,
            offeringId: null,
            value: Map({
              inventoryManagement: preview.getIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.TRACK_QUANTITY])
                ? SHOPIFY
                : null,
            }),
          }),
        ]),
      })
    );
  }

  if (
    preview.hasIn([ATTRIBUTE.QUANTITY, 'operation']) && (
      !preview.hasIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.TRACK_QUANTITY]) ||
      preview.getIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.TRACK_QUANTITY])
    )
  ) {
    payload.push(
      Map({
        type: preview.getIn([ATTRIBUTE.QUANTITY, 'operation']),
        value: List([
          Map({
            combination: null,
            offeringId: null,
            value: preview.getIn([ATTRIBUTE.QUANTITY, VALUE]),
          }),
        ]),
      })
    );
  }

  return { payload };
}
